import { Tooltip, Zoom, IconButton } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { MdInfo as InfoIcon } from 'react-icons/md';

interface IProps {
    notes: string
    stopPropagation?: boolean
}

let useStyles = makeStyles()(() => ({
    btnInfo: {
        color: '#00a1ff'
    },
}));

let ViewIconButton = ({ notes, stopPropagation }: IProps) => {
    let { classes } = useStyles();
    return (
        <Tooltip TransitionComponent={Zoom} title={notes}>
            <IconButton
                className={classes.btnInfo}
                size="small"
                onClick={(ev: any) => {
                    if (stopPropagation === true) {
                        ev.stopPropagation();
                    }
                }}
            >
                <InfoIcon />
            </IconButton>
        </Tooltip>
    )
}

export default ViewIconButton;